import { render } from "./AccessibleApplications.vue?vue&type=template&id=18f8ea74&scoped=true"
import script from "./AccessibleApplications.vue?vue&type=script&lang=js"
export * from "./AccessibleApplications.vue?vue&type=script&lang=js"

import "./AccessibleApplications.vue?vue&type=style&index=0&id=18f8ea74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f8ea74"]])

export default __exports__